function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { handleErrorModal } from '../../components/Toast';
import Cookies from 'js-cookie';
import { apiError } from '@/utils/apiError';
var statusArr = [403, 500];
var retryableErrorCodes = ['RequestTimeout', 'InternalError', 'CoreAPIUnavailable', 'CloudIntegrationError'];
export var api = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 60000 // 30-second default timeout
});
// Axios retry config
axiosRetry(api, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: function retryCondition(error) {
        var _error$response, _error$response2;
        var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
        var errorCodeValue = (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.errors) === null || _error$response2 === void 0 ? void 0 : _error$response2.errorCode;
        return status !== undefined && statusArr.includes(status) && retryableErrorCodes.includes(errorCodeValue);
    }
});
/** ------------------------------------------------
 * Timeout Retry with Exponential Backoff
 * If a request times out (>60s), retry up to
 * MAX_TIMEOUT_RETRIES times with an increasing
 * timeout. After all retries are exhausted an
 * error toast is shown to the user.
 * ------------------------------------------------ */
var INITIAL_TIMEOUT_MS = 60000;
var MAX_TIMEOUT_RETRIES = 5;
var TIMEOUT_BACKOFF_MULTIPLIER = 2; // timeout grows: 60→120→240→480→960s
var isTimeoutError = function isTimeoutError(error) {
    var _error$message;
    return (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED' || (error === null || error === void 0 ? void 0 : error.code) === 'ERR_CANCELED' && /timeout/i.test((_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : '');
};
var isNetworkError = function isNetworkError(error) {
    return !(error !== null && error !== void 0 && error.response) && !isTimeoutError(error) && (error === null || error === void 0 ? void 0 : error.code) !== 'ERR_CANCELED';
};
/** ------------------------------------------------
 * Transient Error Retry Interceptor (Timeout + Network)
 * Retries both timeout and network-level failures with
 * exponential backoff. Shows a toast only after all
 * retries are exhausted.
 *   Timeout:  up to MAX_TIMEOUT_RETRIES (5), timeout
 *             grows: 60→120→240→480→960s
 *   Network:  up to MAX_NETWORK_RETRIES (3), delay
 *             grows: 1→2→4s
 * ------------------------------------------------ */
var MAX_NETWORK_RETRIES = 3;
api.interceptors.response.use(function (response) {
    return response;
}, /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(error) {
        var config, timeout, network, _config$__timeoutRetr, _config$__networkRetr, retryCount, delay;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        config = error === null || error === void 0 ? void 0 : error.config;
                        timeout = isTimeoutError(error);
                        network = isNetworkError(error);
                        if (!(!config || !timeout && !network)) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2, Promise.reject(error));
                    case 1:
                        if (!timeout) {
                            _context.n = 3;
                            break;
                        }
                        config.__timeoutRetryCount = (_config$__timeoutRetr = config.__timeoutRetryCount) !== null && _config$__timeoutRetr !== void 0 ? _config$__timeoutRetr : 0;
                        if (!(config.__timeoutRetryCount >= MAX_TIMEOUT_RETRIES)) {
                            _context.n = 2;
                            break;
                        }
                        config.skipErrorToast = true;
                        handleErrorModal(true, 'The request timed out after multiple attempts. Please try again later.');
                        return _context.a(2, Promise.reject(error));
                    case 2:
                        config.__timeoutRetryCount += 1;
                        config.timeout = Math.round(INITIAL_TIMEOUT_MS * Math.pow(TIMEOUT_BACKOFF_MULTIPLIER, config.__timeoutRetryCount));
                        console.warn("[Retry] Timeout attempt ".concat(config.__timeoutRetryCount, "/").concat(MAX_TIMEOUT_RETRIES, " for ").concat(config.url, " \u2014 new timeout: ").concat(config.timeout, "ms"));
                        _context.n = 5;
                        break;
                    case 3:
                        config.__networkRetryCount = (_config$__networkRetr = config.__networkRetryCount) !== null && _config$__networkRetr !== void 0 ? _config$__networkRetr : 0;
                        if (!(config.__networkRetryCount >= MAX_NETWORK_RETRIES)) {
                            _context.n = 4;
                            break;
                        }
                        config.skipErrorToast = true;
                        handleErrorModal(true, 'A network error occurred after multiple attempts. Please check your connection and try again.');
                        return _context.a(2, Promise.reject(error));
                    case 4:
                        config.__networkRetryCount += 1;
                    case 5:
                        retryCount = timeout ? config.__timeoutRetryCount : config.__networkRetryCount;
                        delay = Math.min(1000 * Math.pow(2, retryCount - 1), 10000);
                        _context.n = 6;
                        return new Promise(function (resolve) {
                            return setTimeout(resolve, delay);
                        });
                    case 6:
                        return _context.a(2, api(config));
                }
        }, _callee);
    }));
    return function (_x) {
        return _ref.apply(this, arguments);
    };
}());
// Add token to request headers
api.interceptors.request.use(function (config) {
    var token = Cookies.get('access_token');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    var uiTraceId = Cookies.get('ui_trace_id');
    if (uiTraceId) {
        config.headers['X-Request-ID'] = uiTraceId;
        config.headers['X-UI-Trace-ID'] = uiTraceId;
    }
    return config;
});
/** -------------------------------
 * Token Refresh with Request Queue
 ---------------------------------- */
var isRefreshing = false;
var failedQueue = [];
var processQueue = function processQueue(error) {
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    failedQueue.forEach(function (prom) {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve(token !== null && token !== void 0 ? token : '');
        }
    });
    failedQueue = [];
};
var refreshToken = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var refreshToken, response;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.n) {
                    case 0:
                        refreshToken = Cookies.get('refresh_token');
                        if (refreshToken) {
                            _context2.n = 1;
                            break;
                        }
                        return _context2.a(2, null);
                    case 1:
                        _context2.n = 2;
                        return axios.get("".concat(process.env.REACT_APP_API_URL, "/authentication/token/refresh"), {
                            headers: {
                                refreshtoken: refreshToken
                            },
                            withCredentials: true
                        });
                    case 2:
                        response = _context2.v;
                        return _context2.a(2, response === null || response === void 0 ? void 0 : response.data);
                }
        }, _callee2);
    }));
    return function refreshToken() {
        return _ref2.apply(this, arguments);
    };
}();
/** Extract a user-facing error message from an Axios-shaped error. */
var extractErrorMessage = function extractErrorMessage(axiosError) {
    var _axiosError$response, _apiError$code;
    var errors = (_axiosError$response = axiosError.response) === null || _axiosError$response === void 0 || (_axiosError$response = _axiosError$response.data) === null || _axiosError$response === void 0 ? void 0 : _axiosError$response.errors;
    if (!errors)
        return 'An error occurred';
    var code = errors.errorCode;
    if (code && (_apiError$code = apiError[code]) !== null && _apiError$code !== void 0 && _apiError$code.message)
        return apiError[code].message;
    if (errors.description)
        return errors.description;
    return 'An error occurred';
};
/** Build an enhanced Error object that carries backend metadata. */
var buildEnhancedError = function buildEnhancedError(message, axiosError, statusCode, originalError) {
    var _axiosError$response2;
    var enhanced = new Error(message);
    enhanced.backendResponse = (_axiosError$response2 = axiosError.response) === null || _axiosError$response2 === void 0 ? void 0 : _axiosError$response2.data;
    enhanced.statusCode = statusCode;
    enhanced.originalError = originalError;
    return enhanced;
};
/** Clear all auth cookies/session and redirect to home. */
var clearSessionAndRedirect = function clearSessionAndRedirect() {
    Cookies.remove('access_token');
    Cookies.remove('refresh_token');
    Cookies.remove('user');
    Cookies.remove('ui_trace_id');
    sessionStorage.clear();
    if (window.location.pathname !== '/') {
        window.location.href = '/';
    }
};
var errorHandler = function errorHandler(error) {
    var _axiosError$response3, _axiosError$config3;
    var axiosError = error;
    var statusCode = (_axiosError$response3 = axiosError.response) === null || _axiosError$response3 === void 0 ? void 0 : _axiosError$response3.status;
    // Timeout errors should not clear the session
    if (isTimeoutError(error)) {
        var _axiosError$config;
        if (!((_axiosError$config = axiosError.config) !== null && _axiosError$config !== void 0 && _axiosError$config.skipErrorToast)) {
            handleErrorModal(true, 'The request timed out. Please try again later.');
        }
        return Promise.reject(error);
    }
    // Only clear session on an explicit 401 — not on network/CORS/DNS errors
    if (statusCode === 401) {
        clearSessionAndRedirect();
        return Promise.reject(new Error('Authentication error'));
    }
    // No status code means a network-level failure (no HTTP response at all).
    // The network retry interceptor already retried with backoff and showed a
    // toast when all retries were exhausted, so just reject here.
    if (!statusCode) {
        var _axiosError$config2;
        if (!((_axiosError$config2 = axiosError.config) !== null && _axiosError$config2 !== void 0 && _axiosError$config2.skipErrorToast)) {
            handleErrorModal(true, 'A network error occurred. Please check your connection and try again.');
        }
        return Promise.reject(error);
    }
    var errorMessage = extractErrorMessage(axiosError);
    if (!((_axiosError$config3 = axiosError.config) !== null && _axiosError$config3 !== void 0 && _axiosError$config3.skipErrorToast)) {
        handleErrorModal(true, errorMessage);
    }
    var enhancedError = buildEnhancedError(errorMessage, axiosError, statusCode, error);
    return Promise.reject(enhancedError);
};
/** Store tokens from a successful refresh response. */
var storeTokens = function storeTokens(accessToken, refreshTokenValue) {
    Cookies.set('access_token', accessToken, {
        secure: true,
        sameSite: 'Strict'
    });
    Cookies.set('refresh_token', refreshTokenValue, {
        secure: true,
        sameSite: 'Strict'
    });
};
/** Retry the original request with a new access token. */
var retryWithNewToken = function retryWithNewToken(originalRequest, accessToken) {
    originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
    return api(originalRequest);
};
/** Handle token refresh when a 401 is received and we are the first caller. */
var handleRefreshAsInitiator = /*#__PURE__*/ function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(originalRequest, error) {
        var result, refreshError, _t;
        return _regenerator().w(function (_context3) {
            while (1)
                switch (_context3.p = _context3.n) {
                    case 0:
                        isRefreshing = true;
                        originalRequest._retry = true;
                        _context3.p = 1;
                        _context3.n = 2;
                        return refreshToken();
                    case 2:
                        result = _context3.v;
                        if (result !== null && result !== void 0 && result.accessToken) {
                            _context3.n = 3;
                            break;
                        }
                        processQueue(new Error('Token refresh failed'), null);
                        return _context3.a(2, errorHandler(error));
                    case 3:
                        storeTokens(result.accessToken, result.refreshToken);
                        processQueue(null, result.accessToken);
                        return _context3.a(2, retryWithNewToken(originalRequest, result.accessToken));
                    case 4:
                        _context3.p = 4;
                        _t = _context3.v;
                        refreshError = _t instanceof Error ? _t : new Error('Token refresh failed');
                        processQueue(refreshError, null);
                        return _context3.a(2, errorHandler(refreshError));
                    case 5:
                        _context3.p = 5;
                        isRefreshing = false;
                        return _context3.f(5);
                    case 6:
                        return _context3.a(2);
                }
        }, _callee3, null, [[1, 4, 5, 6]]);
    }));
    return function handleRefreshAsInitiator(_x2, _x3) {
        return _ref3.apply(this, arguments);
    };
}();
/** Enqueue the request to wait for an in-progress token refresh. */
var enqueueFailedRequest = function enqueueFailedRequest(originalRequest) {
    return new Promise(function (_resolve, _reject) {
        failedQueue.push({
            resolve: function resolve(token) {
                _resolve(retryWithNewToken(originalRequest, token));
            },
            reject: function reject(err) {
                errorHandler(err);
                _reject(err);
            }
        });
    });
};
// Main response interceptor
api.interceptors.response.use(function (response) {
    return response;
}, /*#__PURE__*/ function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(error) {
        var _error$response3;
        var originalRequest, isUnauthorized, isAlreadyRetried;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.n) {
                    case 0:
                        originalRequest = error.config;
                        isUnauthorized = ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 401;
                        isAlreadyRetried = originalRequest === null || originalRequest === void 0 ? void 0 : originalRequest._retry;
                        if (!(!isUnauthorized || isAlreadyRetried || !originalRequest)) {
                            _context4.n = 1;
                            break;
                        }
                        return _context4.a(2, errorHandler(error));
                    case 1:
                        if (!isRefreshing) {
                            _context4.n = 2;
                            break;
                        }
                        return _context4.a(2, enqueueFailedRequest(originalRequest));
                    case 2:
                        return _context4.a(2, handleRefreshAsInitiator(originalRequest, error));
                }
        }, _callee4);
    }));
    return function (_x4) {
        return _ref4.apply(this, arguments);
    };
}());
